import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import LenderInfo from './LenderInfo';
import Alert from '../../common/Alert';
import { Loader } from '@home-loan-experts/ui-helper';

const PostcodeResult = ({ resultRef,loader }) => {
    const postcode = useSelector((state) => state.postcode);
    const [values, setValue] = useState(null);

    useEffect(() => {
        const setValues = () => {
            if (!postcode) return null;
            setValue(postcode);
        };
        setValues();
    }, [postcode]);

    return (
        <>
        <div className='result-row--head'>
                <h4 className="text-bold title">Results</h4>
                 {true &&
                            <p className='loader-text'>
                               <span className={loader.text}> {loader.text}</span> <Loader isLoading={loader.loader}/> 
                                 <i className='material-icons'>{loader.icon}</i> 
                            </p>}
              </div>
        <div className="row result-row" ref={resultRef}>
          
            <div className="col-md-6 result-col mb-lg-0">
                <LenderInfo postcode={{ lender: 1, value: get(values, 'lender1') }} />
            </div>
            <div className="col-md-6 result-col">
                <LenderInfo postcode={{ lender: 2, value: get(values, 'lender2') }} />
            </div>
            <div className="col-md-12 mt-20">
                {get(values, 'tip') && (
                    <>

                        <Alert info={{ message: get(values, 'tip'), type: 'warning' }} />
                    </>
                )}


            </div>
        </div>
        </>
    )
}

export default PostcodeResult
